import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Container, MenuItem, ReportDetailsByJurisdiction } from './models';
import { prefix } from './constants';
import { ComplianceCentralService } from './views/compliance-central/compliance-central.service';
import { AppService } from './services';
import { TranslateService } from '@ngx-translate/core';
import { EntityDirectoryService } from './views/entity-directory/entity-directory.service';
import { GlobalGuideService } from './views/global-guide/global-guide.service';
import { Router } from '@angular/router';
import { Policies } from '../shared/constants';
import { hasReportsOnlyAccess } from '../shared/validators/access';
import { LaunchDarklyService } from '../shared/services/launch-darkly.service';

@Component({
  selector: 'v2',
  templateUrl: './v2.component.html',
  styleUrls: ['./v2.component.scss']
})
export class V2Component implements OnInit {
  getEntitiesPolicy: string[] = [Policies.GET_ENTITIES];
  getMneWorldPolicy: string[] = [Policies.GET_MNE_WORLD];
  getComplianceCentralPolicy: string[] = [Policies.COMPLIANCE_CENTRAL_ACCESS];
  getCoreApiUpdatePolicy: string[] = [Policies.CORE_API_UPDATE_CONTROLLER_SAVED_MATCHED_DATA];
  redirectToNewUI: boolean;

  items: Array<MenuItem> = hasReportsOnlyAccess() ? [{
    title: 'Compliance Central',
    id: 'compliance-central',
    icon: 'fas fa-bullseye',
    route: `/${prefix}/compliance`,
    src: 'legacy/assets/img/v2-icons/Central.svg',
    policies: this.getComplianceCentralPolicy
  }] : [{
    title: 'Compliance Central',
    id: 'compliance-central',
    icon: 'fas fa-bullseye',
    route: `/${prefix}/compliance`,
    src: 'legacy/assets/img/v2-icons/Central.svg',
    policies: this.getComplianceCentralPolicy
  }, {
    title: 'Entity Directory',
    id: 'entity-directory',
    icon: 'fas fa-book-open',
    route: `/${prefix}/entity-directory`,
    routeAliases: [`/${prefix}/entity/`],
    src: 'legacy/assets/img/v2-icons/Directory.svg',
    policies: this.getEntitiesPolicy
  }, {
    title: 'Global Guide',
    id: 'global-guide',
    icon: 'fas fa-globe',
    route: `/${prefix}/global-guide`,
    src: 'legacy/assets/img/v2-icons/Global.svg',
    policies: this.getMneWorldPolicy
  }];

  containersArr: Array<{ name: string, value: number, selected: boolean }>;
  reportDetailsByJurisdiction: ReportDetailsByJurisdiction[];

  @Input() containerId: string;
  constructor(public service: AppService,
    private complianceCentralService: ComplianceCentralService,
    private entityDirectoryService: EntityDirectoryService,
    private globalGuideService: GlobalGuideService,
    private translate: TranslateService,
    private _router: Router,
    private titleService: Title,
    private _launchDarklyService: LaunchDarklyService
  ) {}

  ngOnInit(): void {
    this.loadBranding().then((branding)=>{
      this.titleService.setTitle(branding.pageTittle);
    });
    this._router.navigate([prefix, 'compliance']);
    this.containersArr = this.toContainersDropdownModel(this.service.containers);
  }

  async loadBranding(): Promise<any> {
    await this._launchDarklyService.client.waitUntilReady();
    const rebrandingEnabled = this._launchDarklyService.client.variation('tp-rebranding', false);
    const branding = { pageTittle: 'Transfer Pricing' };
    if (rebrandingEnabled) {
      branding.pageTittle = 'Exactera';
    }
    this._launchDarklyService.client.close();
    return branding;
  }
  /**
   * Given an array of containers, transforms the array items into a model
   * suitable for displaying in a dropdown.
   * @todo Model the output to the dropdown model shape.
   */
  toContainersDropdownModel(containers: Container[]): Array<{ name: string, value: number, selected: boolean }> {
    return containers.map(({ displayName, containerId }) => ({
      name: displayName,
      value: containerId,
      selected: this.service.currentContainer.containerId === containerId
    }));
  }

  goToNewExperience(): void {
    window.location.href = '/newexperience/';
  }
}
